export class RespostaPergunta {
    constructor(public texto: string, public usuarioRede: string = '', public codigoPergunta: string) {}
}
